const NAME_SPACE = 'RidingSchoolPage';

export { NAME_SPACE };
